export default "/images/end.svg"